import { render } from "./SwitchControl.vue?vue&type=template&id=387fb74c&scoped=true"
import script from "./SwitchControl.vue?vue&type=script&lang=js"
export * from "./SwitchControl.vue?vue&type=script&lang=js"

import "./SwitchControl.vue?vue&type=style&index=0&id=387fb74c&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387fb74c"]])

export default __exports__